<template>
  <component v-if="footerComponent" :is="footerComponent" class="footer"></component>
</template>

<script>
import { footerHelpers } from '@/components/public/footers/index.js'

export default {
  name: 'Footer',
  computed: {
    footerComponent () {
      const { component, disabled } = this.$route.meta.footer || { component: footerHelpers.getFooterComponentName(), disabled: false }
      return disabled ? null : () => component ? import(`@/components/public/footers/${component}`) : null
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  padding-top: 5rem;

	@include mobile {
		padding-top: 3rem;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/public/footers/Footer.vue